import React from 'react'
import PropTypes from 'prop-types'

import DownloadWidget from './DownloadWidget'

const ViewOptions = props => {
  const {
    isPercentFormat,
    updateScoreFormat,
    filters,
    startDownload,
    showAccountingButton,
    isCanvasCourse,
  } = props

  const percentsClasses = `btn btn-sm btn-default ${
    isPercentFormat ? 'active' : ''
  }`
  const scoresClasses = `btn btn-sm btn-default ${
    isPercentFormat ? '' : 'active'
  }`
  return (
    <div className="pull-right">
      <div
        id="viewOptionsContainer"
        className="btn-group"
        data-toggle="buttons"
      >
        <label
          id="viewScoresButton"
          className={scoresClasses}
          onClick={() => {
            updateScoreFormat(false)
          }}
        >
          <input type="radio" name="assessment_view" value="score" />
          View Scores
        </label>
        <label
          id="viewPercentagesButton"
          className={percentsClasses}
          onClick={() => {
            updateScoreFormat(true)
          }}
        >
          <input type="radio" name="assessment_view" value="score" />
          View Percentages
        </label>
      </div>
      <DownloadWidget
        filters={filters}
        startDownload={startDownload}
        showAccountingButton={showAccountingButton}
        isCanvasCourse={isCanvasCourse}
      />
    </div>
  )
}

ViewOptions.propTypes = {
  isPercentFormat: PropTypes.bool.isRequired,
  filters: PropTypes.object,
  updateScoreFormat: PropTypes.func.isRequired,
  startDownload: PropTypes.func.isRequired,
  showAccountingButton: PropTypes.bool,
  isCanvasCourse: PropTypes.bool,
}

export default ViewOptions
